module.exports = __webpack_public_path__ + "static/media/classroom_view_find_video.e80805fa.mov";